
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 15 11","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.75 6.5a2.25 2.25 0 11-4.502-.002A2.25 2.25 0 019.75 6.5zM15 4a2 2 0 00-2-2h-1.5a.913.913 0 01-.5-.207L9.707.5A1.872 1.872 0 008.5 0h-2a1.872 1.872 0 00-1.207.5L4 1.793A.913.913 0 013.5 2H2a2 2 0 00-2 2v5a2 2 0 002 2h11a2 2 0 002-2V4z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    